export const ROUTES: Record<string, string> = {
  home: "/",
  "mrr-dashboard": "/mrr-legacy",
  "mrr-sandbox": "/mrr",
  "demo-funnel": "/demo-funnel",
  "signup-funnel": "/signup-funnel",
  attributions: "/attributions",
  "churn-leading-indicators": "/churn",
  "llm-usage": "/llm-usage",
  "marloo-wau": "/marloo-wau",
  "onboarding-baseline": "/onboarding-baseline",
  "embedding-comparison": "/embedding-comparison",
  "document-qa": "/document-qa",
  leads: "/leads",
  "payment-failures": "/payment-failures",
  "misc-document-generation": "/misc/document-generation",
};

export function pathToId(pathname: string): string {
  if (pathname === "/demo-funnel-secret") return "demo-funnel";
  const match = Object.entries(ROUTES).find(([, p]) => p === pathname);
  return match ? match[0] : "home";
}

export function idToPath(id: string): string {
  return ROUTES[id] ?? "/";
}
